var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlcoholimetroNoSuperado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#630021;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-alcoholimetro-no-superado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_8",
    "data-name": 8
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("g", {
    id: "icono"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.63,170.4H66a11,11,0,0,1-9.52-16.49l24.81-43h0a11,11,0,0,1,19,0l24.82,43a11,11,0,0,1-9.52,16.49ZM90.81,113.82a2.55,2.55,0,0,0-2.25,1.3h0l-24.82,43A2.6,2.6,0,0,0,66,162h49.64a2.6,2.6,0,0,0,2.25-3.9l-24.82-43A2.56,2.56,0,0,0,90.81,113.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.31,150.31a3.65,3.65,0,1,1-2.5-1A3.4,3.4,0,0,1,93.31,150.31ZM94,127a.48.48,0,0,1,.14.34V147a.46.46,0,0,1-.14.34.45.45,0,0,1-.34.14H88a.44.44,0,0,1-.34-.14.46.46,0,0,1-.14-.34V127.3a.48.48,0,0,1,.48-.48h5.68A.49.49,0,0,1,94,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.37,51.82v6.54H77.16v5.83H64.38a12.72,12.72,0,0,0,0,25.44H77.16v5.83l18.85,0V58.46h61.43V163.94H138v6.64h26.08V51.82ZM64.38,83a6.08,6.08,0,0,1,0-12.16H77.16V83ZM83.8,65h5.57V88.82H83.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,67.44H104.29v37.61h43.86Zm-6.64,31H110.94V74.08h30.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.87,149.59a3.32,3.32,0,0,1-1.29-6.38,11.19,11.19,0,1,0-10.52-19.65A3.32,3.32,0,1,1,116.4,118a17.83,17.83,0,1,1,16.76,31.31A3.27,3.27,0,0,1,131.87,149.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlcoholimetroNoSuperado);
export default __webpack_public_path__ + "static/media/ic-alcoholimetro-no-superado.866abcb1a5e2650a16f75896bae0fdce.svg";
export { ForwardRef as ReactComponent };